import React, { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";

//Common
import { Snackbar } from "../../common/VFX-UI";

//App

import ClaimForm from "./ClaimForm";
import { ClaimContext } from "./ClaimContainer";
import { ClaimFormContainerProps, SnackbarState } from "../../../types";
import { ClaimDto } from "../../../app/model/api/types/dto";
import claimApi from "../../../app/model/api/claimApi";
import { apiErrorMessage } from "../../../utility/lib/error";
import { ClaimViewModel } from "../../../viewModels";
import { EMPTY_GUID } from "../../../utility/constants";

export const ClaimFormContainer: React.FC<ClaimFormContainerProps> = (
  props
) => {
  const { onClose, onShowSuccess } = props;
  const claimContext = useContext(ClaimContext);

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = claimContext?.id ? "Claim updated" : "New Claim added";

  const onShowErrorSnackbar = (errorMessage: string) => {
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });
  };

  const onCloseSnackbar = () => {
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });
  };

  const { status, mutate } = useMutation<void, Error, ClaimDto>({
    mutationFn: async (payload: ClaimDto) => {
      const response = await claimApi.save(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
  });

  const handleOnSubmit = async (values: ClaimViewModel) => {
    const claim: ClaimDto = values.toDto();
    mutate(claim);
  };

  let stateId =
    claimContext?.claimTypeId !== null &&
    claimContext?.claimTypeId !== undefined
      ? [claimContext.claimTypeId]
      : [];

  const initialValues = claimContext?.id
    ? new ClaimViewModel(
        claimContext.data?.id ?? null,
        claimContext.data?.name ?? null,
        claimContext.data?.description ?? null,
        claimContext.data?.claimTypeId !== null &&
        claimContext.data?.claimTypeId !== undefined
          ? [claimContext.data?.claimTypeId]
          : null,
        claimContext.data?.sortValue ?? null,
        claimContext.data?.isActive ?? null
      )
    : new ClaimViewModel(EMPTY_GUID, "", "", stateId, 100, true);

  return (
    <>
      <ClaimForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleOnSubmit}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};
